import React from 'react'
import PropTypes from 'prop-types'
import Icon from '../app_components/Icon'

function DashboardSectionShell({ icon, iconColor, iconSolid, title, subtitle, children }) {
  return (
    <section className="dashboardHomeSection">
      <header className="dashboardHomeSection__header">
        <div className="dashboardHomeSection__titleRow">
          <span className="dashboardHomeSection__iconCircle" aria-hidden="true">
            <Icon name={icon} size={20} color={iconColor} solid={iconSolid} />
          </span>
          <div className="dashboardHomeSection__headingCopy">
            <h2 className="dashboardHomeSection__title">{title}</h2>
            {subtitle && (
              <p className="dashboardHomeSection__subtitle">{subtitle}</p>
            )}
          </div>
        </div>
      </header>
      <div className="dashboardHomeSection__body">
        {children}
      </div>
    </section>
  )
}

DashboardSectionShell.propTypes = {
  icon: PropTypes.string.isRequired,
  iconColor: PropTypes.string,
  iconSolid: PropTypes.bool,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  children: PropTypes.node,
}

DashboardSectionShell.defaultProps = {
  iconColor: '#494CE9',
  iconSolid: true,
}

export default DashboardSectionShell
